import * as React from "react";
import Shared from "../shared";
import { InDepthQuestionProps } from "./props";

export class DateQuestion extends React.Component<InDepthQuestionProps, undefined> {
    constructor(props: InDepthQuestionProps) {
        super(props);
        this.updateAnswer = this.updateAnswer.bind(this);
    }

    updateAnswer(newVal: Date): void {
        this.props.requestAnswerModification(a => {
            a.dateAnswer = newVal;
        });
    }

    title(): string {
        return this.props.question.title;
    }

    render(): JSX.Element {
        return (
            <Shared.DateInput
                className="small-input-field"
                onCommit={this.updateAnswer}
                initial={this.props.answer.dateAnswer}
                key={this.props.question.id}
                label={this.title()}
            />
        );
    }
}
